var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileBilling(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3643 4.00488C10.2481 3.68606 9.81827 3.66624 9.66309 3.94531L9.63574 4.00488L7.9873 8.53809L7.86719 8.86719L7.53809 8.9873L3.00488 10.6357C2.68606 10.7519 2.66624 11.1817 2.94531 11.3369L3.00488 11.3643L7.53809 13.0127L7.86719 13.1328L7.9873 13.4619L9.63574 17.9951C9.75188 18.3139 10.1817 18.3338 10.3369 18.0547L10.3643 17.9951L12.0127 13.4619L12.1328 13.1328L12.4619 13.0127L16.9951 11.3643C17.3139 11.2481 17.3338 10.8183 17.0547 10.6631L16.9951 10.6357L12.4619 8.9873L12.1328 8.86719L12.0127 8.53809L10.3643 4.00488Z",
    stroke: "#C1C7D4",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileBilling);
export default __webpack_public_path__ + "static/media/profile-billing.e2b1052bc0d17f30b07239d09897422d.svg";
export { ForwardRef as ReactComponent };